import { FC, useMemo } from 'react';

import { getRequestedLanguages } from '../../../../locale/languages';
import { ACCOUNT_TYPES } from '../../../../utils/enum/AccountTypes';

interface Props {
    customerCode: string;
    properties: string[];
}

const HeadRow: FC<Props> = ({ customerCode, properties }) => {
    const language = getRequestedLanguages(window.berardi_accountUserData.language);

    const limitedProperties = useMemo(() => {
        if (properties.length > 6) {
            return properties.slice(0, 6);
        }
        return properties;
    }, [properties]);

    const artCodeCell = useMemo(() => {
        if (customerCode) {
            return (
                <>
                    <b>{language.product.table.art_code}</b> /<br /> {language.product.table.art_code_customer}
                </>
            );
        }
        return <b>{language.product.table.art_code}</b>;
    }, [customerCode]);

    const showAddToCartButton = useMemo(() => {
        if (
            window.berardi_accountUserData.accountType &&
            window.berardi_accountUserData.accountType != ACCOUNT_TYPES.Agent &&
            window.berardi_accountUserData.accountType != ACCOUNT_TYPES.CustomerService &&
            window.berardi_accountUserData.accountType != ACCOUNT_TYPES.Guest
        ) {
            return true;
        }
        return false;
    }, []);

    return (
        <tr className="br-table__headRow">
            <th className="br-table__headRowCell -flex2">{artCodeCell}</th>
            {limitedProperties.map((property: string) => {
                return <th className="br-table__headRowCell">{property}</th>;
            })}
            <th className="br-table__headRowCell"></th>
            {window.berardi_accountUserData.accountType != ACCOUNT_TYPES.Prospect && (
                <th className="br-table__headRowCell">{language.product.table.unit_price}</th>
            )}
            <th className="br-table__headRowCell -numberPieces">{language.product.table.number_of_pieces}</th>
            {customerCode && window.berardi_accountUserData.accountType != ACCOUNT_TYPES.Prospect ? (
                <th className="br-table__headRowCell -price">{language.product.table.total_price}</th>
            ) : null}
            {showAddToCartButton && <th className="br-table__headRowCell"></th>}
        </tr>
    );
};

export default HeadRow;
